import * as styles from "./AlphaIndexArrow.css";
import type { ArrowVariants } from "./AlphaIndexArrow.css";

import { Icon } from "@frontend/components/atoms/Icon";

export type AlphaIndexArrowProps = {
  direction: NonNullable<ArrowVariants["direction"]>;
  onClick: () => void;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  // state: State<{ compact: boolean; up: boolean; down: boolean }>;
  // enabled: State<boolean>;
  state: { compact: boolean; up: boolean; down: boolean };
  enabled: boolean;
};

export function AlphaIndexArrow({
  direction,
  onClick,
  onMouseEnter,
  onMouseLeave,
  state,
  enabled,
}: AlphaIndexArrowProps) {
  return (
    <span
      className={styles.arrow({
        direction,
        compact: state.compact && enabled,
        canScroll: state[direction] && enabled,
      })}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <Icon name={direction === "up" ? "ChevronUp" : "ChevronDown"} size="sm" />
    </span>
  );
}
